import { render, staticRenderFns } from "./singout.vue?vue&type=template&id=0a683d88&scoped=true&"
import script from "./singout.vue?vue&type=script&lang=js&"
export * from "./singout.vue?vue&type=script&lang=js&"
import style0 from "./singout.vue?vue&type=style&index=0&id=0a683d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a683d88",
  null
  
)

export default component.exports